const INTERLOCUTORIA_DA_LEGGERE = 'interlocutoria da leggere';

const toUpperString = (value) => String(value ?? '').trim().toUpperCase();
const toNumber = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
};

const isTruthyFlag = (value) => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value > 0;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 's' || normalized === 'si';
  }
  return false;
};

export const isIncTask = (task = {}) => {
  const tipoTask = toUpperString(task?.tcf_campo32 ?? task?.tipoTask);
  if (tipoTask === 'INCARICO') {
    return true;
  }

  const processo = toUpperString(task?.processo);
  if (processo === 'INC' || processo.startsWith('INCARIC')) {
    return true;
  }
  return false;
};

export const getChatUnreadCount = (task = {}) => {
  const unreadCandidates = [
    task?.chatUnreadCount,
    task?.chat_unread_count,
    task?.numeroMessaggiChatNonLetti,
    task?.numero_messaggi_chat_non_letti,
  ];
  const firstUnreadValue = unreadCandidates.find((value) => {
    const parsed = toNumber(value);
    return parsed > 0;
  });

  return toNumber(firstUnreadValue);
};

export const hasUnreadChatNotification = (task = {}) => {
  if (getChatUnreadCount(task) > 0) {
    return true;
  }
  return isTruthyFlag(task?.hasNewChatMessages)
    || isTruthyFlag(task?.has_new_chat_messages)
    || isTruthyFlag(task?.chatNotification)
    || isTruthyFlag(task?.chat_notification)
    || isTruthyFlag(task?.hasChatNotification)
    || isTruthyFlag(task?.has_chat_notification);
};

export const shouldShowChatIcon = (task = {}) => isIncTask(task) && hasUnreadChatNotification(task);

export const normalizeTaskForChatFlag = (task = {}) => {
  if (!task || typeof task !== 'object') {
    return task;
  }

  if (!shouldShowChatIcon(task)) {
    return task;
  }

  return {
    ...task,
    motivoRisveglio: INTERLOCUTORIA_DA_LEGGERE,
  };
};

export const normalizeTaskListForChatFlag = (tasks) => {
  if (!Array.isArray(tasks)) {
    return tasks;
  }
  return tasks.map((task) => normalizeTaskForChatFlag(task));
};

export { INTERLOCUTORIA_DA_LEGGERE };
